import type { AddressUsage } from '~/api/DeliveryAddress';
import { DeliveryMethods } from '~/api/ETA';

import { resolveAddressUsage } from './addressUsage';

/**
 * Maps a saved address usage tag to the delivery method it represents.
 * Pickup → CLICK_AND_COLLECT, delivery → COURIER_DELIVERY. An untagged address
 * resolves through the tenant default, which is pickup where every address is
 * a pickup point (see {@link resolveAddressUsage}).
 */
export const deliveryMethodForUsage = (
  usage?: AddressUsage,
): DeliveryMethods =>
  resolveAddressUsage(usage) === 'pickup'
    ? DeliveryMethods.CLICK_AND_COLLECT
    : DeliveryMethods.COURIER_DELIVERY;

/**
 * Inverse of {@link deliveryMethodForUsage}: the saved-address type that
 * fulfils a given delivery method.
 */
export const usageForDeliveryMethod = (
  method: DeliveryMethods,
): AddressUsage =>
  method === DeliveryMethods.CLICK_AND_COLLECT ? 'pickup' : 'delivery';
